import component from './src/search-container.vue';
export default {
  install(Vue){
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/search-container/index.js